// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"qq-z","breadcrumbForward":"rq-z","breadcrumbBack":"sq-z","selected":"tq-z"};